export default "__VITE_ASSET__sZVKpkDW__"